export default __webpack_public_path__ + "static/media/designProLogo.e8a93c15.svg";